module.exports = __webpack_public_path__ + "static/media/รายงานสรุปขอกู้ตามประเภทอาชีพ.ba8c9fc4.xls";